import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { useAuth } from '../contexts/AuthContext';
import { Package, ShoppingCart, CreditCard, User } from 'lucide-react';

const Dashboard = () => {
  const { user } = useAuth();

  const stats = [
    {
      id: 'total-orders',
      title: 'Total Pesanan',
      value: '0',
      icon: <Package className="h-8 w-8 text-primary" />,
      description: 'Pesanan yang telah dibuat'
    },
    {
      id: 'in-process',
      title: 'Dalam Proses',
      value: '0',
      icon: <ShoppingCart className="h-8 w-8 text-yellow-500" />,
      description: 'Pesanan sedang diproses'
    },
    {
      id: 'completed',
      title: 'Selesai',
      value: '0',
      icon: <CreditCard className="h-8 w-8 text-green-500" />,
      description: 'Pesanan yang selesai'
    }
  ];

  return (
    <div className="min-h-screen py-12">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-4xl font-bold font-['Outfit'] mb-2">Dashboard</h1>
          <p className="text-muted-foreground">
            Selamat datang, {user?.full_name || 'User'}!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {stats.map((stat) => (
            <Card key={stat.id} className="rounded-2xl">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <div>
                    <CardDescription className="text-sm">{stat.title}</CardDescription>
                    <CardTitle className="text-3xl font-bold font-['Outfit'] mt-2">
                      {stat.value}
                    </CardTitle>
                  </div>
                  <div>{stat.icon}</div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">{stat.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card className="rounded-2xl">
            <CardHeader>
              <CardTitle className="font-['Outfit']">Pesanan Terbaru</CardTitle>
              <CardDescription>Belum ada pesanan</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground text-center py-8">
                Anda belum memiliki pesanan. Mulai dengan melihat{' '}
                <a href="/packages" className="text-primary hover:underline">
                  paket umrah
                </a>
                {' '}yang tersedia.
              </p>
            </CardContent>
          </Card>

          <Card className="rounded-2xl">
            <CardHeader>
              <CardTitle className="font-['Outfit']">Profil Saya</CardTitle>
              <CardDescription>Informasi akun Anda</CardDescription>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-center space-x-3">
                <User className="h-5 w-5 text-primary" />
                <div>
                  <p className="text-sm font-medium">{user?.full_name}</p>
                  <p className="text-xs text-muted-foreground">{user?.email}</p>
                </div>
              </div>
              <div className="pt-4">
                <p className="text-sm text-muted-foreground">
                  Role: <span className="font-medium capitalize">{user?.role}</span>
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
